"use client";

import { getOrCreateDeviceId } from "./device-id";

export type SecurityLogParams = {
  event_type:
    | "auth.login_success"
    | "auth.login_failure"
    | "auth.signup"
    | "auth.logout"
    | "auth.phone_verification_success"
    | "auth.phone_verification_failure"
    | "auth.password_change_success"
    | "auth.password_change_failure"
    | "account.delete_requested"
    | "account.deleted";
  success: boolean;
  failure_reason?: string | null;
  auth_method?: string | null;
};

export function getClientContext() {
  if (typeof window === "undefined") return {};
  const tz = -new Date().getTimezoneOffset();
  const lang = navigator.language ?? navigator.languages?.[0] ?? null;
  const w = window.screen?.width;
  const h = window.screen?.height;
  const screenSize = w != null && h != null ? `${w}x${h}` : null;
  const platform = navigator.platform ?? null;
  const referrer = typeof document !== "undefined" ? document.referrer || undefined : undefined;
  return { timezone_offset: tz, language: lang, screen_size: screenSize, platform, referrer };
}

export function appendSecurityLogFormData(fd: FormData): void {
  fd.append("device_id", getOrCreateDeviceId());
  const ctx = getClientContext();
  if (ctx.timezone_offset != null) fd.append("timezone_offset", String(ctx.timezone_offset));
  if (ctx.language != null) fd.append("language", ctx.language);
  if (ctx.screen_size != null) fd.append("screen_size", ctx.screen_size);
  if (ctx.platform != null) fd.append("platform", ctx.platform);
  if (ctx.referrer != null) fd.append("referrer", ctx.referrer);
}

export function logSecurityEvent(params: SecurityLogParams): void {
  const deviceId = getOrCreateDeviceId();
  const ctx = getClientContext();
  fetch("/api/security/log", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event_type: params.event_type,
      success: params.success,
      failure_reason: params.failure_reason ?? null,
      auth_method: params.auth_method ?? null,
      device_id: deviceId,
      ...ctx,
      meta: { source: "client" },
    }),
    keepalive: true,
  }).catch(() => {});
}
